import { useEffect } from 'react';
import {
  useActiveLab,
  useActivePractice,
  useDispatch,
} from '@witmetrics/data-store';
import { currentDate } from '@witmetrics/utils/time';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import Overlay from '@/components/Overlay';
import Agenda from '@/components/Agenda';
import Header from './Header';
import { classes, fetchOrderTasks, fetchProjectTasks } from './utils';

export type AgendaOverlayProps = {
  onClose: () => void;
};

export default function AgendaOverlay({ onClose }: AgendaOverlayProps) {
  const dispatch = useDispatch();
  const { activeCalendarDate, onOpenAgenda, onApiError } = useAppState();
  const activePractice = useActivePractice();
  const activeLab = useActiveLab();
  const [isFetchingData, toggleFetchingData] = useToggle(true);

  useEffect(() => {
    if (activeCalendarDate) fetchData();
    else onOpenAgenda(currentDate());
  }, [activeCalendarDate]);

  const fetchData = async () => {
    try {
      toggleFetchingData(true);
      if (activePractice) {
        dispatch.addProjectTasks(
          await fetchProjectTasks(activePractice.id, activeCalendarDate!)
        );
      } else if (activeLab) {
        dispatch.addOrderTasks(
          await fetchOrderTasks(activeLab.id, activeCalendarDate!)
        );
      }
      toggleFetchingData(false);
    } catch (err) {
      toggleFetchingData(false);
      onApiError(err, 'Error fetching tasks', () => fetchData());
    }
  };

  return (
    <Overlay className={classes.overlay} variant="glass" onClose={onClose}>
      <div className={classes.wrapper}>
        <Header onClose={onClose} />
        <Agenda
          showCurrentTime
          showCurrentTimeDot
          className={classes.agenda}
          hourHeight={75}
          date={activeCalendarDate!}
        />
      </div>
    </Overlay>
  );
}
